/**
 * i18n del front-admin — estilo gettext: la CLAVE es el texto en español.
 *
 * Regla de robustez: si una traducción falta, t() devuelve el español literal
 * — nunca una clave rota ni un string vacío. Por eso internacionalizar es
 * incremental: las vistas aún no envueltas siguen funcionando en español.
 *
 * Los diccionarios viven fragmentados por área en js/config/i18n/ (un archivo
 * por vista grande) para que se puedan trabajar en paralelo sin conflictos;
 * config/i18n/index.js los mergea en un solo mapa
 *   { 'texto español': { pt: '…', en: '…', ru: '…' } }
 *
 * El idioma por defecto sale del brand (VITE_DEFAULT_LOCALE: Brasil=pt) y el
 * operador puede pisarlo con el selector del panel (persistido por navegador).
 */

import { TRADUCCIONES } from '../config/i18n/index.js';


const CLAVE_STORAGE_IDIOMA_ADMIN = 'adminIdioma';
// Fase 1: es + pt. Para sumar en/ru basta agregar la entrada acá y rellenar
// esas columnas en los diccionarios — el código de las vistas no se toca.
export const IDIOMAS_ADMIN = [
    { codigo: 'es', etiqueta: 'Español', bandera: '🇪🇸' },
    { codigo: 'pt', etiqueta: 'Português', bandera: '🇧🇷' },
    { codigo: 'en', etiqueta: 'English', bandera: '🇺🇸' },
    { codigo: 'ru', etiqueta: 'Русский', bandera: '🇷🇺' },
];

/** Siguiente idioma en el ciclo del botón-bandera (es → pt → en → ru → es…). */
export function siguienteIdiomaAdmin() {
    const i = IDIOMAS_ADMIN.findIndex(x => x.codigo === _idiomaActual);
    return IDIOMAS_ADMIN[(i + 1) % IDIOMAS_ADMIN.length];
}

function _idiomaDefaultDelBrand() {
    // VITE_DEFAULT_LOCALE viene del brand JSON (ej. 'pt-BR', 'es-PE') —
    // normalizamos al código corto que usan los diccionarios.
    const locale = import.meta.env.VITE_DEFAULT_LOCALE || 'es';
    return String(locale).slice(0, 2).toLowerCase();
}

let _idiomaActual = (() => {
    const guardado = localStorage.getItem(CLAVE_STORAGE_IDIOMA_ADMIN);
    if (guardado && IDIOMAS_ADMIN.some(i => i.codigo === guardado)) return guardado;
    const delBrand = _idiomaDefaultDelBrand();
    return IDIOMAS_ADMIN.some(i => i.codigo === delBrand) ? delBrand : 'es';
})();

export function getIdiomaAdmin() {
    return _idiomaActual;
}

/**
 * Cambia el idioma del panel y recarga: los templates se generan en render,
 * así que el reload es la forma simple y total de re-traducir todo.
 */
export function setIdiomaAdmin(codigo) {
    if (!IDIOMAS_ADMIN.some(i => i.codigo === codigo)) return;
    localStorage.setItem(CLAVE_STORAGE_IDIOMA_ADMIN, codigo);
    location.reload();
}

/**
 * Traduce un texto de UI. Clave = el texto español tal cual se escribe en el
 * código. Soporta interpolación posterior: traducir SOLO los segmentos
 * estáticos (t('Guardar')) y concatenar las variables fuera.
 */
export function t(textoEspanol) {
    if (_idiomaActual === 'es') return textoEspanol;
    const entrada = TRADUCCIONES[textoEspanol];
    return (entrada && entrada[_idiomaActual]) || textoEspanol;
}

/**
 * Traduce los elementos estáticos del index.html marcados con [data-i18n]
 * (menú lateral, status badge). Se llama una vez en App.init(); el contenido
 * dinámico generado por JS ya sale traducido vía t() en los templates.
 */
export function traducirElementosEstaticosDelDom() {
    if (_idiomaActual === 'es') return;
    const marcados = document.querySelectorAll('[data-i18n]');
    for (let i = 0; i < marcados.length; i++) {
        marcados[i].textContent = t(marcados[i].textContent.trim());
    }
}
